/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="container-fluid">
          <Row>
            <Col sm={6}>
              <span className="text-info">{new Date().getFullYear()}</span>
              {' '}
              <span className="text-info">©</span>
            </Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
                Crafted with
                {' '}
                <i className="mdi mdi-heart text-danger" />
                {' '}
                by
                {' '}
                <a href="https://www.shopjimmy.com" target="_blank" rel="noreferrer" className="text-reset">ShopJimmy</a>
              </div>
            </Col>
          </Row>
        </div>
      </footer>
    );
  }
}

export default Footer;
